import { api, type Api } from "@api/bot-base-api-request";
import { useQuery } from "@tanstack/react-query";

const BOT_GET_COPYTRADE_DATA_QUERY_KEY = "bot-get-copytrade-data";

type BotGetCopyTradeDataParams = {
  appPubKey: string;
  userId: string;
  userWallet: string;
  chainId: number;
};

const fetchBotCopyTradeData = async (
  api: Api,
  params: BotGetCopyTradeDataParams
) => api.get("copyTrade/getCopyTradeData", { searchParams: params }).json();

const useGetBotCopyTradeData = (params: BotGetCopyTradeDataParams) =>
  useQuery({
    queryKey: [BOT_GET_COPYTRADE_DATA_QUERY_KEY, params],
    queryFn: async () => fetchBotCopyTradeData(api, params),
  });

export {
  useGetBotCopyTradeData,
  fetchBotCopyTradeData,
  BOT_GET_COPYTRADE_DATA_QUERY_KEY,
};
